import { IItem, StampItem } from "../../../../domain/document/items";
import { Point, Rectangle, Size } from "../../../../domain/drawing";
import { BeanTypes, IStampItemBean, ITypeDefinable } from "../beans/items";
import { ImageSource } from "../ImageSource";
import { IObjectTranslatable } from "./IObjectTranslatable";

export class StampItemTranslator  implements IObjectTranslatable {
  constructor(private _getToken: () => string) {
  }
  
  toItem(item: ITypeDefinable, formatId: number, groupId: number, documentId: number, executionMode: string): IItem {
    const bean = item as IStampItemBean;
    const result = new StampItem();
    result.privateId = (bean as any).privateId; // フロントエンド独自パラメータ.
    result.uniqueKey = bean.uniqueKey;
    result.id = bean.id;
    result.sectionObjectUid = bean.sectionObjectUid;
    result.isEditable = true; // TODO:特に問題なければプロパティを削除する
    result.isAdditional = !!bean.isAdditional;
    result.isDeleted = !!bean.isDeleted;
    result.isVisible = !!bean.isVisible;
    result.typeDetail = bean.typeDetail;
    result.viewTitle = bean.viewTitle;
    result.printBehavior.shouldPrint = !!bean.printVisible;
    result.printBehavior.shouldPreview = !!bean.previewVisible;
    result.name = bean.name;
    result.geometry.rectangle = new Rectangle(new Point(bean.x, bean.y), new Size(bean.width, bean.height));
    result.imageSource = new ImageSource(this._getToken, formatId, documentId, bean.imageStoragePlace, bean.imageGuid);
    result.stampUserCode = bean.stampUserCode;
    result.isStamped = bean.isStamped;
    return result;
  }

  toBean(item: IItem): ITypeDefinable {
    const target = item as StampItem;
    const bean: IStampItemBean = {
      type: BeanTypes.Stamp,
      uniqueKey: target.uniqueKey,
      id: target.id,
      sectionObjectUid: target.sectionObjectUid,
      name: target.name,
      isVisible: target.isVisible,
      printVisible: target.printBehavior.shouldPrint,
      previewVisible: target.printBehavior.shouldPreview,
      x: target.geometry.rectangle.x,
      y: target.geometry.rectangle.y,
      width: target.geometry.rectangle.width,
      height: target.geometry.rectangle.height,
      isAdditional: target.isAdditional,
      isDeleted: target.isDeleted,
      typeDetail: target.typeDetail,
      viewTitle: target.viewTitle,
      stampUserCode: target.stampUserCode,
      isStamped: target.isStamped,
      imageStoragePlace: target.imageSource.imageSourceKind,
      imageGuid: target.imageSource.imageGuid,
    };
    return bean;
  }
}
